import React from 'react';
import AgenciesList from '../../components/Views/AgenciesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';

const Agencies = () => <AgenciesList />;

Agencies.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

Agencies.getLayout = page => (
  <Layout isBottomNavigation={false} isShowBackButton isShowCloseButton={false}>
    {page}
  </Layout>
);

export default Agencies;
